import { ActionTree } from 'vuex'
import { RootState } from '../types'
import { ProfileState } from './types'

export const actions: ActionTree<ProfileState, RootState> = {}
